import { render, staticRenderFns } from "./orders_index.vue?vue&type=template&id=2d999b06&"
import script from "./orders_index.vue?vue&type=script&lang=js&"
export * from "./orders_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports